import Glide, { Controls, Breakpoints, Swipe, Autoplay } from '@glidejs/glide/dist/glide.modular.esm.js';

export const utilities = {
  ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  },
  supportsPassive: () => {
    let supportsPassive = false;
    try {
      var opts = Object.defineProperty({}, 'passive', {
        get: function() {
          supportsPassive = true;
        }
      });
      window.addEventListener('testPassive', null, opts);
      window.removeEventListener('testPassive', null, opts);
    } catch (e) { }
    
    return supportsPassive;
  },
  offset: (el) => {
    const box = el.getBoundingClientRect();
    const docElem = document.documentElement;
    return {
      top: box.top + window.scrollY - docElem.clientTop,
      left: box.left + window.scrollX - docElem.clientLeft
    };
  },
  animate: () => {
		document.querySelectorAll('.animation').forEach((animation) => {
			const offset = animation.dataset.animationOffset !== undefined ? animation.dataset.animationOffset : 20;
			const delay = animation.dataset.animationDelay;
			const duration = animation.dataset.animationDuration;

			const animationObserver = new IntersectionObserver((entries) => {
				if (entries[0].isIntersecting) {
					if (window.innerWidth >= 992 && delay) {
						animation.style.transitionDelay = delay + 'ms';
					}

					if (duration) {
						animation.style.transitionDuration = duration + 'ms';
					}
	
					if (animation.tagName === 'IMG' && !animation.complete) {
						animation.addEventListener('load', () => {
								animation.classList.add('animate');
						});
					} else {
						animation.classList.add('animate');
					}
				}
			},
			{
				rootMargin: '-' + offset + 'px 0px',
			});

			animationObserver.observe(animation);
		});
	},
  sliders: () => {
    const sliders = document.querySelectorAll('.pp-slider');

    if (!sliders.length === 0) {
      return;
    }
    
    sliders.forEach(node => {
      const slider = new Glide(node, {
        type: node.getAttribute('data-type') ? node.getAttribute('data-type') : 'carousel',
        startAt: node.getAttribute('data-startAt') ? node.getAttribute('data-startAt') : 0,
        perView: node.getAttribute('data-perView') ? node.getAttribute('data-perView') : 1,
        gap: node.getAttribute('data-gap') ? node.getAttribute('data-gap') : 0,
        animationDuration: node.getAttribute('data-animationDuration') ? node.getAttribute('data-animationDuration') : 700,
        autoplay: node.getAttribute('data-autoplay') ? node.getAttribute('data-autoplay') : false,
        hoverpause: node.getAttribute('data-hoverpause') ? node.getAttribute('data-hoverpause') : false,
        rewind: node.getAttribute('data-rewind') ? node.getAttribute('data-rewind') : false,
        bound: node.getAttribute('data-bound') ? node.getAttribute('data-bound') : true,
        rewindDuration: node.getAttribute('data-rewindDuration') ? node.getAttribute('data-rewindDuration') : 700,
        peek: {
          before: node.getAttribute('data-peekBefore') ? node.getAttribute('data-peekBefore') : 0,
          after: node.getAttribute('data-peekAfter') ? node.getAttribute('data-peekAfter') : 0,
        },
        breakpoints: {
          576: {
            perView: node.getAttribute('data-sm-perView') ? node.getAttribute('data-sm-perView') : 1,
            peek: {
              before: node.getAttribute('data-sm-peekBefore') ? node.getAttribute('data-sm-peekBefore') : (node.getAttribute('data-peekBefore') ? 20 : 0),
              after: node.getAttribute('data-sm-peekAfter') ? node.getAttribute('data-sm-peekAfter') : (node.getAttribute('data-peekAfter') ? 20 : 0)
            }
          },
          768: {
            perView: node.getAttribute('data-md-perView') ? node.getAttribute('data-md-perView') : (node.getAttribute('data-perView') ? node.getAttribute('data-perView') : 1),
            peek: {
              before: node.getAttribute('data-md-peekBefore') ? node.getAttribute('data-md-peekBefore') : (node.getAttribute('data-peekBefore') ? 100 : 0),
              after: node.getAttribute('data-md-peekAfter') ? node.getAttribute('data-md-peekAfter') : (node.getAttribute('data-peekAfter') ? 100 : 0)
            }
          },
          992: {
            perView: node.getAttribute('data-lg-perView') ? node.getAttribute('data-lg-perView') : (node.getAttribute('data-perView') ? node.getAttribute('data-perView') : 1),
            peek: {
              before: node.getAttribute('data-lg-peekBefore') ? node.getAttribute('data-lg-peekBefore') : (node.getAttribute('data-peekBefore') ? 100 : 0),
              after: node.getAttribute('data-lg-peekAfter') ? node.getAttribute('data-lg-peekAfter') : (node.getAttribute('data-peekAfter') ? 100 : 0)
            }
          },
          1200: {
            perView: node.getAttribute('data-xl-perView') ? node.getAttribute('data-xl-perView') : (node.getAttribute('data-perView') ? node.getAttribute('data-perView') : 1),
            peek: {
              before: node.getAttribute('data-xl-peekBefore') ? node.getAttribute('data-xl-peekBefore') : (node.getAttribute('data-peekBefore') ? 150 : 0),
              after: node.getAttribute('data-xl-peekAfter') ? node.getAttribute('data-xl-peekAfter') : (node.getAttribute('data-peekAfter') ? 150 : 0)
            }
          },
          1400: {
            perView: node.getAttribute('data-xxl-perView') ? node.getAttribute('data-xxl-perView') : (node.getAttribute('data-perView') ? node.getAttribute('data-perView') : 1),
            peek: {
              before: node.getAttribute('data-xxl-peekBefore') ? node.getAttribute('data-xxl-peekBefore') : (node.getAttribute('data-peekBefore') ? 150 : 0),
              after: node.getAttribute('data-xxl-peekAfter') ? node.getAttribute('data-xxl-peekAfter') : (node.getAttribute('data-peekAfter') ? 150 : 0)
            }
          }
        }
      }).mount({ Controls, Breakpoints, Swipe, Autoplay });

      if (node.getAttribute('data-autoplay') && node.getAttribute('data-autoplay') !== false) {
        slider.pause();
        const sliderObserver = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) {
            if (window.innerWidth >= 992) {
              slider.play();
            }
          } else {
            slider.pause();
          }
        }, {rootMargin: '-100px 0px'});
        sliderObserver.observe(node);
      }
    });
  },
  thumbnailSliders: () => {
    const sliders = document.querySelectorAll('.pp-thumbnails-slider');

    if (!sliders.length === 0) {
      return;
    }

    sliders.forEach(node => {
      const image = node.querySelector('.pp-thumbnails-slider__slider');
      const thumbnails = node.querySelector('.pp-thumbnails-slider__thumbnails');
      
      const imageCarousel = new Glide(image, {
        type: image.getAttribute('data-type') ? image.getAttribute('data-type') : 'carousel',
        startAt: image.getAttribute('data-startAt') ? image.getAttribute('data-startAt') : 0,
        perView: image.getAttribute('data-perView') ? image.getAttribute('data-perView') : 1,
        gap: image.getAttribute('data-gap') ? image.getAttribute('data-gap') : 0,
        animationDuration: image.getAttribute('data-animationDuration') ? image.getAttribute('data-animationDuration') : 700,
        autoplay: image.getAttribute('data-autoplay') ? image.getAttribute('data-autoplay') : false,
        hoverpause: image.getAttribute('data-hoverpause') ? image.getAttribute('data-hoverpause') : false,
        rewind: image.getAttribute('data-rewind') ? image.getAttribute('data-rewind') : false,
        rewindDuration: image.getAttribute('data-rewindDuration') ? image.getAttribute('data-rewindDuration') : 700,
        peek: {
          before: image.getAttribute('data-peekBefore') ? image.getAttribute('data-peekBefore') : 0,
          after: image.getAttribute('data-peekAfter') ? image.getAttribute('data-peekAfter') : 0,
        }
      }).mount({ Controls, Breakpoints, Swipe, Autoplay });

      const thumbnailsCarousel = new Glide(thumbnails, {
        type: thumbnails.getAttribute('data-type') ? thumbnails.getAttribute('data-type') : 'carousel',
        startAt: thumbnails.getAttribute('data-startAt') ? thumbnails.getAttribute('data-startAt') : 0,
        perView: thumbnails.getAttribute('data-perView') ? thumbnails.getAttribute('data-perView') : 1,
        gap: thumbnails.getAttribute('data-gap') ? thumbnails.getAttribute('data-gap') : 0,
        animationDuration: thumbnails.getAttribute('data-animationDuration') ? thumbnails.getAttribute('data-animationDuration') : 700,
        autoplay: thumbnails.getAttribute('data-autoplay') ? thumbnails.getAttribute('data-autoplay') : false,
        hoverpause: thumbnails.getAttribute('data-hoverpause') ? thumbnails.getAttribute('data-hoverpause') : false,
        rewind: thumbnails.getAttribute('data-rewind') ? thumbnails.getAttribute('data-rewind') : false,
        rewindDuration: thumbnails.getAttribute('data-rewindDuration') ? thumbnails.getAttribute('data-rewindDuration') : 700,
        peek: {
          before: thumbnails.getAttribute('data-peekBefore') ? thumbnails.getAttribute('data-peekBefore') : 0,
          after: thumbnails.getAttribute('data-peekAfter') ? thumbnails.getAttribute('data-peekAfter') : 0,
        }
      }).mount({ Controls, Breakpoints, Swipe, Autoplay });

      // Connect thumbnailsCarousel to imageCarousel
      thumbnailsCarousel.on('run', (e) => {
        imageCarousel.go(e.direction + thumbnails.index);
      });

       // Connect imageCarousel to thumbnailsCarousel
      imageCarousel.on('run', (e) => {
        thumbnailsCarousel.go(e.direction + imageCarousel.index);
      });

      // Handle thumbnail click
      thumbnails.querySelectorAll('.glide__slide').forEach(slide => {
        slide.addEventListener('click', (e) => {
          imageCarousel.go('=' + (e.target.dataset.index));
          thumbnailsCarousel.go('=' + (e.target.dataset.index));
        });
      });
    });
  },
  getItems: async (params, callback) => {
    await fetch(app.ajax_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      body: new URLSearchParams({
        action: params.action,
        nonce: app.ajax_nonce,
        page: params.page || 1,
        category: params.category || false,
        type: params.type || 'get',
      }).toString()
    })
      .then(response => {
        return response.text();
      })
      .then(data => {
        callback(data);
      })
      .catch(error => {
        //handle error
      });
  },
  more: async (params) => {
    const more = document.getElementById('more');
    const container = document.getElementById('items');
    const totalPages = more.dataset.total;
    let page = 1;

    if (!more || !container) {
      return;
    }

    if (+totalPages === 1) {
      more.classList.add('d-none');
      return;
    }

    more.addEventListener('click', (e) => {
      e.preventDefault();
      page = page + 1;
      utilities.getItems({ ...params, type: 'more', page: page}, (data) => {
        if (!data || +totalPages === +page) {
          more.classList.add('d-none');
        }
        container.insertAdjacentHTML('beforeend', data);
        utilities.animate();
      });
    });
  },
  scrollTop: (el, value) => {
    let win;
    if (el.window === el) {
      win = el;
    } else if (el.nodeType === 9) {
      win = el.defaultView;
    }
  
    if (value === undefined) {
      return win ? win.pageYOffset : el.scrollTop;
    }
  
    if (win) {
      win.scrollTo(win.pageXOffset, value);
    } else {
      el.scrollTop = value;
    }
  },
  offset: (el) => {
    const box = el.getBoundingClientRect();
    const docElem = document.documentElement;
    return {
      top: box.top + window.scrollY - docElem.clientTop,
      left: box.left + window.scrollX- docElem.clientLeft
    };
  },
  quantitiesTemplate: (obj) => {
    return `
      <div id="qty-message" class="qty-message bg-dark-grey text-white px-3 py-2 rounded-2 mt-3">
        <span class="fw-bold">${obj.title}</span> available from a minimum quantity of <span class="fw-bold">${obj.minimum_qty} ${+obj.minimum_qty === 1 ? obj.units_plural.slice(0, -1) : obj.units_plural}</span>.
        ${obj.customHide !== 'on' ? `<br>Extensive customization and bulk discounts available from <span class="fw-bold">${obj.customization_qty} ${+obj.customization_qty === 1 ? obj.units_plural.slice(0, -1) : obj.units_plural}</span>.` : ''}
        ${obj.additional_message !== '' ? `<br>` + obj.additional_message : ''}
      </div>
    `;
  },
  handleFormInterest: () => {
    const form = document.getElementById('gform_1');

    if (!form) {
      return;
    }

    const interest = document.getElementById('input_1_8');

    interest.addEventListener('change', () => {
      const quantity = document.getElementById('input_1_10');
      const message = document.getElementById('qty-message');

      if (interest.value === '') {
        if (message) {
          message.remove();
        }
        return;
      }

      if (interest.value === 'Inspirations') {
        quantity.setAttribute('min', 0);
        quantity.value = 5000;
        if (message) {
          message.remove();
        }
        return;
      }

      if (interest.value === 'Services') {
        quantity.setAttribute('min', 0);
        if (message) {
          message.remove();
        }
        return;
      }

      const index = app.quantities.findIndex(entry => entry.title === interest.value);

      if (message) {
        message.remove();
      }
      quantity.setAttribute('min', app.quantities[index].minimum_qty);
      quantity.value = app.quantities[index].preset_qty;
      interest.insertAdjacentHTML('afterend', utilities.quantitiesTemplate(app.quantities[index]));
    });
  },
}